import { render, staticRenderFns } from "./InviteOpener.vue?vue&type=template&id=0baeb6ac"
import script from "./InviteOpener.vue?vue&type=script&lang=js"
export * from "./InviteOpener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports